
  <template>
  <div id="wrapper" :key="valuekey">
    <div class="col-xl-12">
      <div class="card-box">
        <div class="form-row">
          <div class="form-group col-md-5">
            <label class="col-form-label">
              <strong>{{$t('string.msg.dashboard.orders.period')}}</strong>
            </label>
            
            <select v-model="nDays" @change="onChangeDay" class="form-control">
              <option :value="'customized'">{{$t('string.msg.dashboard.orders.change.customized.date')}}</option>
              <option :value="1">{{$t('string.msg.dashboard.orders.change.one.day')}}</option>
              <option :value="2">{{$t('string.msg.dashboard.orders.change.two.day')}}</option>
              <option :value="3">{{$t('string.msg.dashboard.orders.change.three.day')}}</option>              
              <option :value="7">{{$t('string.msg.dashboard.orders.change.seven.day')}}</option>
              <option :value="15">{{$t('string.msg.dashboard.orders.change.fifteen.day')}}</option>
              <option :value="28" selected>{{$t('string.msg.dashboard.orders.change.twentyeight.day')}}</option>              
            </select>
          </div>

          <div class="form-group col-md-5">
            <label class="col-form-label">
              <strong>{{$t('string.msg.dashboard.orders.select.status.label')}}</strong>
            </label>
            <select v-model="filters.statusOrder" class="form-control">
              <option selected value="WAITING_FOR_RESPONSE">{{$t('string.msg.dashboard.orders.table.status.waiting')}}</option>
              <option :value="null">{{$t('string.msg.dashboard.orders.select.status.all')}}</option>              
              <option
                value="IN_PROGRESS"
              >{{$t('string.msg.dashboard.orders.table.status.progress')}}</option>
              <option value="CLOSED">{{$t('string.msg.dashboard.orders.table.status.closed')}}</option>
              <option value="PAID">{{$t('string.msg.dashboard.orders.table.status.paid')}}</option>
            </select>
          </div>

          <div class="form-group col-md-2" v-if="items">
            <h4 class="text-center">{{$t('str.total')}}</h4>
            <h4 class="text-center" style="color:grey">{{items.length}}</h4>
          </div>
        </div>

        <div class="form-row" v-if="nDays=='customized'">

          <div class="form-group col-md-6">
            <label class="col-form-label"><strong>{{$t('string.msg.dashboard.orders.select.datestart')}}</strong></label>
            <input type="date" class="form-control" v-model="filters.beginDate" />
          </div>

          <div class="form-group col-md-6">
            <label class="col-form-label"><strong>{{$t('string.msg.dashboard.orders.select.dateend')}}</strong></label>
            <input type="date" class="form-control" v-model="filters.endDate"/>
          </div>
            
        </div>

        <br />

        <div class="d-flex justify-content-between bd-highlight mb-3">
          <button @click="filter()" class="btn btn-success w-20" >{{$t('string.msg.form.btn.search')}}</button>
          <download-excel
            v-if="items.length>0"
            class="btn btn-primary"
            :fetch="fetchData"
            :fields="json_fields"
            :meta="json_meta"
            type="csv"
            name="parts.xls"
          >Download CSV</download-excel>
        </div>

        <div v-if="items.length==0" class="card text-center">
          <div class="card-body">
            <h5 class="card-title">{{$t('string.msg.dashboard.no.orders')}}</h5>
            <p class="card-text">{{$t('string.msg.dashboard.no.orders.description')}}</p>
          </div>
        </div>


        <br/>


        <div v-if="items.length>0" class="table-responsive">
          <table class="table table-centered table-hover mb-0" id="datatable">
            <thead>
              <tr>
                <th class="border-top-0"></th>
                <th class="border-top-0">{{$t('string.msg.modal.orders.parts.label.requester')}}</th>
                <th
                  class="border-top-0"
                >{{$t('string.msg.dashboard.orders.table.manucfacturer.title')}}</th>
                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.models.title')}}</th>
                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.year.title')}}</th>
                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.family.title')}}</th>
                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.for.title')}}</th>
                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.date.title')}}</th>
                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.status.title')}}</th>
                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.status.title')}}</th>
                <th class="border-top-0">{{$t('string.msg.order.total.company')}}</th>
                <th class="border-top-0"></th>
                <th class="border-top-0"></th>
              </tr>
            </thead>
            <tbody v-bind:key="item._id" v-for="item in items" class="cursor-pointer">
              <tr v-if="item">
                <td>
                  <span v-if="item.isSearchByCompany && item.isSearchByCompany == true">
                    <i class="dripicons-store"></i>
                  </span>
                  <span v-else>
                    <i class="dripicons-user"></i>
                  </span>
                </td>
                <td>
                  <span
                    v-if="item.systemUser && item.isSearchByCompany && item.isSearchByCompany == true"
                  >{{`${camelize(item.company.fantasyName)}`}}</span>
                  <span
                    v-else
                  >{{`${camelize(item.systemUser.firstName)} ${camelize(item.systemUser.lastName)}`}}</span>
                </td>
                <td>
                  <span v-if="item.manufacturer">{{camelize(item.manufacturer.name)}}</span>
                </td>
                <!--<td>
                  <span
                    v-if="item.truckModel && item.truckModel.name"
                  >{{camelize(item.truckModel.name)}}</span>
                </td>
                <td>
                  <span v-if="item.truckYear">{{item.truckYear}}</span>
                </td>-->
                <td>
                  <span
                      v-if="item.truck && item.truck.model"
                    >{{camelize(item.truck.model.name)}}</span>
                </td>
                <td>
                  <span v-if="item.truck">{{item.truck.yearModel}}</span>
                </td>
                <td>
                  <span v-if="item.family">{{camelize(item.family.name)}}</span>
                </td>
                <td>
                  <span
                    v-if="item.manufacturer && item.manufacturer.type=='TRUCK'"
                  >{{toUpperCase($t('string.msg.truck.name'))}}</span>
                  <span
                    v-if="item.manufacturer && item.manufacturer.type=='TRUCK_TRAILER'"
                  >{{toUpperCase($t('string.msg.trucktrailer.name'))}}</span>
                </td>
                <td>
                  <span
                    v-if="item.dateOrder"
                  >{{new Date(item.dateOrder).toLocaleDateString()}} - {{new Date(item.dateOrder).toLocaleTimeString()}}</span>
                </td>
                <td>
                  <span
                    class="status-order"
                    v-if="item.statusOrder.toUpperCase() == 'WAITING_FOR_RESPONSE'"
                    style="background-color:#fabc2a; color:black"
                  >&nbsp;&nbsp;&nbsp; {{$t(item.statusOrder.toUpperCase())}}&nbsp;&nbsp;&nbsp;</span>
                  <span
                    class="status-order"
                    v-if="item.statusOrder.toUpperCase() == 'CLOSED'"
                    style="background-color:gray; color:white"
                  >&nbsp;&nbsp; &nbsp; {{$t(item.statusOrder.toUpperCase())}}&nbsp; &nbsp;&nbsp;</span>
                  <span
                    class="status-order"
                    v-if="item.statusOrder.toUpperCase() == 'PAID'"
                    style="background-color:green; color:white"
                  >&nbsp;&nbsp; &nbsp; {{$t(item.statusOrder.toUpperCase())}}&nbsp; &nbsp;&nbsp;</span>
                  <span
                    class="status-order"
                    v-else-if="item.statusOrder.toUpperCase() == 'IN_PROGRESS'"
                    style="background-color:blue; color:white"
                  >&nbsp;&nbsp; &nbsp; {{$t(item.statusOrder.toUpperCase())}}&nbsp; &nbsp;&nbsp;</span>
                  <p v-if="item.justifyClose && item.statusOrder.toUpperCase() == 'CLOSED'">{{item.justifyClose}}</p> 
                </td>
                <td>
                  <button
                    v-if="item.orders && item.statusOrder.toUpperCase() != 'CLOSED' && item.statusOrder.toUpperCase() != 'PAID'"
                    v-on:click="addCompany(item)"
                    class="btn btn-primary w-70"
                  >{{item.orders.length + ' - ' + $t('string.msg.order.add.company')}}</button>
                </td>
                <td>
                  <button
                    @click="selectItem(item)"
                    class="btn btn-danger w-100"
                  >{{$t('string.msg.dashboard.orders.btn.view')}}</button>
                </td>
                <td>
                  <button
                    v-if="checkClose(item)"
                    v-on:click="confirmArchive(item)"
                    class="text-dark-gray btn btn-warning w-100"
                  >{{$t('string.msg.order.status.close')}}</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <!--paginação-->
        <!--<nav v-if="!filters.beginDate" aria-label="Page navigation example">
         <ul class="pagination justify-content-center">
            <li class="page-item" v-for="index in pages" v-bind:key="index" 
              style="cursor: pointer">
              <a class="page-link" @click="filter(index)">{{index}}</a>
            </li>
          </ul>
        </nav>-->

      </div>
    </div>
    <Spinner />
    <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
    <ModalParts :curOrder="order" :trucks="trucks" />
    <AddCompany :curOrder="order" v-on:confirmation-return="showMesage" />
    <Confirmation
      :title="titleToast"
      :message="messageToast"
      :cancelText="cancelText"
      :yesText="yesText"
      :order="orderSelected"
      v-on:confirmation-return="archive"
    />
    <FlashMessage />
  </div>
</template>

<script>
import Controller from "./CrtListOrdersParts";
import ModalParts from "./Modal/ModalOrderPart";
import Spinner from "../../../components/layout/Spinner";
import Toast from "../../../components/layout/Toast";
import Confirmation from "./Modal/CloseHolder";
import AddCompany from "./Modal/ModalAddCompany";
import Vue from "vue";
import QrcodeVue from "qrcode.vue";
import crono from "vue-crono";
Vue.use(crono);

let beginDate = new Date();
beginDate.setDate(beginDate.getDate() - 1000);

export default {
  name: "ListOrdersParts",
  props: ["valuekey", "order", 'confirmationData'],
  watch: {
    valuekey() {},
    'order'() {
      this.order = this.order;
    },
    'confirmationData'() {
      this.titleToast = this.$t("string.msg.confirm");
      this.messageToast = this.$t("response.close.order.confirmation");
      this.cancelText = this.$t("string.msg.cancel");
      this.yesText = this.$t("string.msg.yes");
      /*this.titleToast = this.confirmationData.titleToast;
      this.messageToast = this.confirmationData.messageToast;
      this.cancelText = this.confirmationData.cancelText;
      this.yesText = this.confirmationData.yesText;*/
      this.orderSelected = this.confirmationData.orderSelected;
    }
  },
  components: {
    Spinner,
    Toast,
    ModalParts,
    Confirmation,
    AddCompany,
  },
  data() {
    return {
      errors: [],
      pages: 0,
      itemsPerPage: 15,
      currentPage: 1,
      titleToast: null,
      messageToast: null,
      messageIdToast: null,
      items: [],
      trucks: [],
      order: null,
      valuekey: 0,
      companies: [],
      nDays: 28,
      orderSelected: null,
      filters: {
        typeOrder: "PARTS",
        //statusOrder: 'WAITING_FOR_RESPONSE',
        statusOrder: null,
        beginDate: null,
        endDate: new Date(),
      },
      data: {
        total: null,
      },
      json_fields: {
        Tipo: "typeOrder",
        Fabricante: "manufacturer.name",
        Familia: "family.name",
        Descricao: "description",
        Data: "dateOrder",
        Status: "statusOrder",
        Caminhoneiro: "systemUser.firstName",
        Email: "systemUser.email",
        Telefone: "systemUser.primaryPhone",
      },
      json_data: [
        {
          typeOrder: null,
          manufacturer: {
            name: null,
          },
          family: {
            name: null,
          },
          description: null,
          Data: null,
          Status: null,
          systemUser: {
            firstName: null,
            email: null,
            primaryPhone: null,
          },
        },
      ],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      totalOrders: 0,
      newOrder: false,
    };
  },
  methods: Controller.methods,
  created() {},
  mounted() {
    Controller.init(this);
  },
  cron: {
    time: 800000,
    method: "load",
  },
  destroyed() {
    clearInterval(this.timer);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style>
</style>
